import { useState } from "react";
import Select from "react-select";
import { mexicoStates } from "../../../../data/mexicoStates";
import { authorityOptions } from "../../../../data/authorityOptions";
import { originOptions } from "../../../../data/originOptions";
import { conceptOptions } from "../../../../data/conceptOptions";

const FilterCasos = ({ data, onFilterChange }) => {
    const [filters, setFilters] = useState({
        authority: null,
        origin: null,
        concept: [],
        state: [],
    });

    const stateOptions = mexicoStates.map((state) => ({
        value: state.code,
        label: state.name,
    }));

    const applyFilters = (currentFilters) => {
        let filtered = data;

        if (currentFilters.authority) {
            filtered = filtered.filter((caso) => caso.authority === currentFilters.authority.value);
        }

        if (currentFilters.origin) {
            filtered = filtered.filter((caso) => caso.origin === currentFilters.origin.value);
        }

        if (currentFilters.concept.length > 0) {
            const conceptValues = currentFilters.concept.map((c) => c.value);
            filtered = filtered.filter((caso) =>
                Array.isArray(caso.concept) &&
                caso.concept.some((item) => conceptValues.includes(item))
            );
        }

        if (currentFilters.state.length > 0) {
            const stateValues = currentFilters.state.map((s) => s.value);
            filtered = filtered.filter((caso) => stateValues.includes(caso.state));
        }

        // IMPORTANTE: Pasar filtros activos a la tabla
        onFilterChange(filtered, currentFilters);
    };

    const handleAuthorityChange = (option) => {
        const newFilters = { ...filters, authority: option };
        setFilters(newFilters);
        applyFilters(newFilters);
    };

    const handleOriginChange = (option) => {
        const newFilters = { ...filters, origin: option };
        setFilters(newFilters);
        applyFilters(newFilters);
    };

    const handleConceptChange = (option) => {
        const newFilters = { ...filters, concept: option || [] };
        setFilters(newFilters);
        applyFilters(newFilters);
    };

    const handleStateChange = (option) => {
        const newFilters = { ...filters, state: option || [] };
        setFilters(newFilters);
        applyFilters(newFilters);
    };

    const handleClearFilters = () => {
        const clearedFilters = {
            authority: null,
            origin: null,
            concept: [],
            state: [],
        };
        setFilters(clearedFilters);
        onFilterChange(data, null);
    };

    const customSelectStyles = {
        control: (base) => ({
            ...base,
            borderColor: "#ccc",
            boxShadow: "none",
            "&:hover": {
                borderColor: "#999",
            },
            fontSize: "14px",
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#3b82f6" : state.isFocused ? "#e3f2fd" : "white",
            color: state.isSelected ? "white" : "black",
        }),
    };

    return (
        <div className="w-full bg-white p-4 rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold rounded-lg p-1 text-white bg-orange-700">Autoridad</label>
                    <Select
                        options={authorityOptions}
                        styles={customSelectStyles}
                        placeholder="Selecciona autoridad..."
                        value={filters.authority}
                        onChange={handleAuthorityChange}
                        isClearable
                        isSearchable
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold rounded-lg p-1 text-white bg-purple-700">Origen</label>
                    <Select
                        options={originOptions}
                        styles={customSelectStyles}
                        placeholder="Selecciona origen..."
                        value={filters.origin}
                        onChange={handleOriginChange}
                        isClearable
                        isSearchable
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold rounded-lg p-1 text-white bg-indigo-700">Concepto</label>
                    <Select
                        isMulti
                        options={conceptOptions}
                        styles={customSelectStyles}
                        placeholder="Selecciona conceptos..."
                        value={filters.concept}
                        onChange={handleConceptChange}
                        isSearchable
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold rounded-lg p-1 text-white bg-emerald-700">Estado</label>
                    <Select
                        isMulti
                        options={stateOptions}
                        styles={customSelectStyles}
                        placeholder="Selecciona estados..."
                        value={filters.state}
                        onChange={handleStateChange}
                        isSearchable
                    />
                </div>
            </div>

            {(filters.authority || filters.origin || filters.concept.length > 0 || filters.state.length > 0) && (
                <div className="mt-3 flex justify-end">
                    <button
                        onClick={handleClearFilters}
                        className="px-4 py-2 bg-gray-300 text-gray-800 text-sm font-semibold rounded-md hover:bg-gray-400 transition"
                    >
                        Limpiar Filtros
                    </button>
                </div>
            )}
        </div>
    );
};

export default FilterCasos;